export default "__VITE_ASSET__550790fa__"